import type { ReactNode } from 'react';
import { Heading1, Heading6 } from '@shopmuchmore/design-system';
import { cn } from '@shopmuchmore/design-system';

interface AccountPageHeaderProps {
    title: string;
    description?: string;
    action?: ReactNode;
    className?: string;
}

export function AccountPageHeader({ title, description, action, className }: AccountPageHeaderProps) {
    return (
        <div className={cn("flex flex-col sm:flex-row sm:items-center justify-between gap-4 py-4 mb-6 bg-secondary text-white! rounded-2xl p-5", className)}>
            <div>
                <Heading1 className="text-2xl font-bold mb-1 text-white">{title}</Heading1>
                {description && <Heading6 className="text-white text-sm md:text-base">{description}</Heading6>}
            </div>
            {action && (
                <div className="flex items-center gap-3">
                    {action}
                </div>
            )}
        </div>
    );
}
